import axios from "axios";
import httpTools from "./httpTools";
import Q from "q";
const Auth = (() => {
  let baseUrl = httpTools.envUrls();
  let subApiUrl = httpTools.subApiUrl();

  return {
    getToken: formData => {
      let defer = Q.defer();
      var postData = {
        type: "base64",
        value: btoa(formData.username + ":" + formData.password),
        namespace: subApiUrl + "/customers"
      };
      axios
        .post(`${baseUrl}/loginTokens`, postData)
        .then(response => {
          defer.resolve(response);
        })
        .catch(err => {
          defer.reject(err);
        });

      return defer.promise;
    }
  };
})();

export default Auth;



// WEBPACK FOOTER //
// ./src/services/http/auth.js